import React, { Component } from 'react';

import './Quote.scss';

export default class Quote extends Component {

    render() {
        const {quote, person} = this.props;

        const quotePlus = person ? `“${quote}”` : quote;

        return (
            <div className="Quote">
                <div className="Quote__vertical-spacer"></div>
                <div className="Quote__text">
                    {quotePlus}
                </div>
                <div className="Quote__person">
                    {person}
                </div>
                <div className="Quote__vertical-spacer"></div>
            </div>
        )
    }

}


// WEBPACK FOOTER //
// ./src/components/DetailPage/Quote/index.js